import React from 'react';
import { Typography } from 'fronton-react';
import { brandShelfTopLineStyles, brandShelfSubtitleStyle } from './styles';

interface CarouselBrandShelfSubtitleProps {
  subtitle?: string;
}

export const CarouselBrandShelfSubtitle = ({ subtitle }: CarouselBrandShelfSubtitleProps) => {
  if (!subtitle) return null;

  return (
    <div className={brandShelfTopLineStyles}>
      <Typography
        className={brandShelfSubtitleStyle}
        variant="s"
        size="body_accent"
        data-qa="products-carousel-subtitle"
      >
        {subtitle}
      </Typography>
    </div>
  );
};
